import React, { useEffect, useRef, useState } from "react";
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import { Search } from "lucide-react";
import DiceCandidatesList from "./dicecandidateslist";
import axios from "axios";
import { suggest } from "../../apiconstants/constants";
import Swal from 'sweetalert2';
import { Link, useLocation } from "react-router-dom";
import WYSIWYGEditor from "../../helpers/WYSIWYGEditor";
import { useForm,Controller } from "react-hook-form";

const stripHtml = (html) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const DiceSearch = () => {
  const locationState = useLocation().state || {}; // get state from Link
const [input, setInput] = useState(locationState.jobDescription || "");
  const { register, handleSubmit, control,setValue, formState,reset } = useForm();  
  const token = localStorage.getItem('jwtToken');
  const [keyword, setKeyword] = useState(locationState.title || "");
  const [location, setLocation] = useState(locationState.location || "");
  const [willingToRelocate, setWillingToRelocate] = useState("");
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [isIntelliSearch, setIsIntelliSearch] = useState(false);
  const [intelliResults, setIntelliResults] = useState([]);
  const [loading, setLoading] = useState(false);
const [jobTitles, setJobTitles] = useState([""]);
const [locations, setLocations] = useState([""]);
const [jdWarning, setJdWarning] = useState(false);
const [suggestions, setSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const [activeInputIndex, setActiveInputIndex] = useState(null);
const typingTimeoutRef = useRef(null);

const addJobTitle = () => setJobTitles([...jobTitles, ""]);
const fetchSuggestions = async (value) => {
  if (!value || value.trim().length < 2) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  try {
    const response = await axios.get(
      `${suggest.APIURL}?query=${encodeURIComponent(value)}`,
      {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
    );

    const data = response.data;

    if (data && Array.isArray(data.suggestions)) {
      setSuggestions(data.suggestions);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  } catch (error) {
    console.error("Error fetching suggestions:", error);
    setSuggestions([]);
    setShowSuggestions(false);
  }
};


const handleJobTitleChange = (index, value) => {
  const updated = [...jobTitles];
  updated[index] = value;
  setJobTitles(updated);

  // mark which input is being edited
  setActiveInputIndex(index);

  // debounce suggestion fetching
  if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
  typingTimeoutRef.current = setTimeout(() => {
    fetchSuggestions(value);
  }, 400);
};


const addLocation = () => setLocations([...locations, ""]);
const handleLocationChange = (index, value) => {
  const updated = [...locations];
  updated[index] = value;
  setLocations(updated);

  // Sync first location to ProfileSearch
  if (index === 0) setLocation(value);
};

const handleIntelliSearch = async (currentPage = 1) => {
  if (!input.trim() || input.trim().length < 150) {
setJdWarning(true);
return;
  }

  const validJobTitles = jobTitles.filter(t => t.trim() !== "");
  if (validJobTitles.length === 0) {
    await Swal.fire({
      icon: "warning",
      title: "❗ Please enter at least one job title for IntelliSearch.",
      confirmButtonColor: "#00a7ac",
    });
    return;
  }
  setShowFilters(true); 
   setIsIntelliSearch(true);
  setSearchTriggered(Date.now());
 
};


 // ✅ Clear all search fields
  const handleClear = () => {
    setInput("");
    setKeyword("");
    setLocation("");
    setWillingToRelocate("");
    setSearchTriggered(false);
    setShowFilters(false);
    setIsIntelliSearch(false);
    setIntelliResults([]);
  };

const handleSearch = () => {
  if (isIntelliSearch) {
    return handleIntelliSearch();
  }

  if (!keyword.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Please enter a keyword before searching",
      confirmButtonColor: "#00a7ac",
    });
    return;
  }

  setShowFilters(true);
  setSearchTriggered(Date.now());
};


const cleanHtmlToText = (html) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;

  let text = tmp.textContent || tmp.innerText || "";
  text = text.replace(/\u00a0/g, " "); // replace &nbsp;
  text = text.replace(/\s+/g, " ").trim(); // collapse spaces

  return text;
};

useEffect(() => {
  if (locationState.jobDescription) {
    // When JD exists from job posts
    setIsIntelliSearch(true);
    setKeyword("");
    setSearchTriggered(false);
    setShowFilters(false);
  }
}, [locationState?.jobDescription]);
useEffect(() => {
  const handleClickOutside = () => setShowSuggestions(false);
  document.addEventListener("click", handleClickOutside);
  return () => document.removeEventListener("click", handleClickOutside);
}, []);

  return (
    <ConsultantLayout>
      <style>{`
        .dice-search-container {
          background-color: #fff;
          padding: 30px 50px;
          border-radius: 6px;
          font-family: "Inter", Arial, sans-serif;
          color: #333;
          margin-bottom: 30px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        }
        .search-title {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 5px;
        }
        .subtitle {
          color: #555;
          font-size: 14px;
          margin-bottom: 25px;
        }
        .search-box {
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 25px;
          background: #fafafa;
        }
        .search-field {
          margin-bottom: 20px;
          position: relative;
        }
        .search-field label {
          font-weight: 600;
          display: block;
          margin-bottom: 5px;
          font-size: 14px;
          color: #333;
        }
        .search-input,
        .search-select,
        textarea.search-input {
          width: 100%;
          padding: 8px 10px;
          font-size: 14px;
          border: 1px solid #ccc;
          border-radius: 4px;
          resize: none;
          transition: border-color 0.2s ease;
        }
        .search-input:focus,
        .search-select:focus,
        textarea.search-input:focus {
          border-color: #00a7ac;
          outline: none;
        }
         .magnifier-btn {
  position: absolute;
  bottom: 8px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #00a7ac;
  z-index: 10; /* <— Add this line */
}
        .magnifier-btn:hover {
          color: #008c8f;
        }
        .search-actions {
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        .btn-primary {
          background-color: #00a7ac;
          border: none;
        }
        .btn-primary:hover {
          background-color: #008c8f;
        }
      `}</style>

    
    <div className="d-flex align-items-center mt-3">
      {locationState.jobDescription && (
        <Link to="/Employer/ListOfJobPosts">
          <i
            className="fa fa-arrow-left"
            style={{
              color: "#00a7ac",
              fontSize: 16,
              marginRight: "10px",
              marginTop: 8,
              cursor: "pointer",
            }}
            aria-hidden="true"
          ></i>
        </Link>
      )}
      <h2 style={{ color: "#00a7ac", marginBottom: 0 }}>Dice Candidates Search</h2>
    </div>
      <hr />
<div className="mb-3 d-flex gap-4">
  <label className="d-flex align-items-center gap-2">
<input
  type="radio"
  name="searchMode"
  checked={isIntelliSearch}
  onChange={() => {
    setIsIntelliSearch(true);
    setKeyword("");
    setSearchTriggered(false); // 👈 add this line
  }}
/>
IntelliSearch
  </label>

  <label className="d-flex align-items-center gap-2">
<input
  type="radio"
  name="searchMode"
  checked={!isIntelliSearch}
  onChange={() => {
    setIsIntelliSearch(false);
    setKeyword("");
    setJdWarning(false);
    setSearchTriggered(false); // 👈 add this line
  }}
/>
    Keyword / Boolean Search
  </label>
</div>

      <div className="">
        <div className="search-box">
          {/* 🧠 IntelliSearch Field */}
{isIntelliSearch && (
  <div className="search-field" style={{ position: "relative" }}>
 <Controller
      control={control}
      name="jobDescription"
      rules={{
        required: { value: true, message: "Job Description Required" },
      }}
      render={({ field: { onChange, onBlur, value, ref } }) => {
      const handleEditorChange = (content) => {
     let sanitized = content
        // force remove inline fonts/sizes
        .replace(/font-family:[^;"]+;?/gi, "")
        .replace(/font-size:[^;"]+;?/gi, "")
        // remove empty paragraphs
        .replace(/<p[^>]*>(\s|&nbsp;)*<\/p>/gi, "")
        // unwrap <p> or <div> (with any attrs) inside list items
        .replace(/<li[^>]*>\s*(?:<p[^>]*>|<div[^>]*>)(.*?)<\/(?:p|div)>\s*<\/li>/gis, "<li>$1</li>")
        // remove a leading <br> inside li
        .replace(/<li[^>]*>\s*<br\s*\/?>\s*/gi, "<li>")
        // collapse multiple <br> into one
        .replace(/(<br\s*\/?>\s*){2,}/gi, "<br>");
    
    
      // wrap with Arial/12px
      const wrapped = `<div style="font-family: Arial; font-size: 12px;">${sanitized}</div>`;
      onChange(wrapped);
    };
    
    
        return (
          <div>
            {/* Label + Button in one row */}
            <div className="d-flex align-items-center mb-2">
              <label style={{ color: "#00a7ac", margin: 0, }}>
                Job Description
              </label>
            
            </div>
    
            {/* Editor */}
          <WYSIWYGEditor
  value={input}
  onChange={(value) => {
    setInput(value);
    const textLength = value.replace(/<[^>]+>/g, "").trim().length; // simple length check without removing styles
    setJdWarning(textLength > 0 && textLength < 150);
  }}
  placeholder="Paste job description here... (min 150 characters)"
/>

    
          
          </div>
        );
      }}
    />
          

   
  </div>
)}

{isIntelliSearch && jdWarning && (
  <p style={{ color: "red", fontSize: "13px", fontWeight: 500 }}>
 Minimum of 150 characters (max 20,000). For searches with less than 150,
    use the "Keyword/Boolean" search.  </p>
)}

{isIntelliSearch && input.trim().length > 0 && (
  <div className="search-field">
    <label>
      Job Titles <span style={{ color: "red" }}>*</span>
    </label>

    {jobTitles.map((title, index) => (
      <div
        key={index}
        className="d-flex flex-column mb-2"
        style={{ position: "relative" }}
      >
        <div className="d-flex align-items-center">
          <input
            type="text"
            className="search-input"
            placeholder="e.g., Full Stack Developer"
            value={title}
            onChange={(e) => handleJobTitleChange(index, e.target.value)}
            onFocus={() => {
              setActiveInputIndex(index);
              if (suggestions.length > 0) setShowSuggestions(true);
            }}
            onBlur={() => {
              // small delay so click on suggestion still works
              setTimeout(() => setShowSuggestions(false), 150);
            }}
          />
          <button
            type="button"
            className="btn btn-link text-success ms-2"
            onClick={addJobTitle}
          >
            <i className="fa fa-plus"></i>
          </button>
        </div>

        {/* ✅ Suggestion Dropdown (only for active input) */}
        {showSuggestions &&
          activeInputIndex === index &&
          suggestions.length > 0 && (
            <ul
              className="suggestions-list"
              style={{
                listStyle: "none",
                padding: "5px",
                marginTop: "4px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                background: "#fff",
                position: "absolute",
                top: "40px",
                zIndex: 999,
                width: "95%",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              {suggestions.map((item, i) => (
                <li
                  key={i}
                  onMouseDown={() => {
                    const updated = [...jobTitles];
                    updated[index] = item;
                    setJobTitles(updated);
                    setShowSuggestions(false);
                  }}
                  style={{
                    padding: "8px 10px",
                    fontSize: 12,
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {item}
                </li>
              ))}
            </ul>
          )}
      </div>
    ))}
  </div>
)}

{!isIntelliSearch && (
  <div className="search-field">
    <label>Keyword <span style={{ color: "red" }}>*</span></label>
    <input
      className="search-input"
      value={keyword}
      onChange={(e) => setKeyword(e.target.value)}
      placeholder="e.g., Java Architect"
    />
  </div>
)}


          {/* Location & Relocation */}
       <div className="search-field">
  <label>Locations</label>
{locations.map((loc, index) => (
  <><div key={index} className="d-flex align-items-center mb-2">
    <input
      type="text"
      className="search-input"
      placeholder="City, State, Zip, Time Zone"
      value={loc}
      onChange={(e) => handleLocationChange(index, e.target.value)} />
    {isIntelliSearch && (
      <button
        type="button"
        className="btn btn-link text-success ms-2"
        onClick={addLocation}
        title="Add another Location"
      >
        <i className="fa fa-plus"></i>
      </button>
    )}
  </div></>
))}
<div style={{ flex: 1 }}>
      <label>Willing To Relocate</label>
      <select
        className="search-select"
        value={willingToRelocate}
        onChange={(e) => setWillingToRelocate(e.target.value)}
      >
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
    </div>
</div>


          {/* Buttons */}
          <div className="search-actions">
            <button
              type="button"
              className="btn btn-secondary px-4"
              onClick={handleClear}
              disabled={loading}
            >
              Clear All
            </button>
              <button
              className="btn btn-primary px-4"
               title="Run Profile Search"
              onClick={(e) => {
                e.target.blur();
                handleSearch();
              }}
              disabled={loading}
            >
              {loading ? "Searching..." : "Search"}
            </button>
          </div>
        </div>
      </div>
 
  {searchTriggered && showFilters && (
  <div>
    <DiceCandidatesList
      keyword={keyword}
      location={location}
      willingToRelocate={willingToRelocate}
      searchTriggered={searchTriggered}
      isIntelliSearch={isIntelliSearch}
      intelliInput={cleanHtmlToText(input)}
      intelliJobTitles={jobTitles}
      intelliLocations={locations}
    />

   
  </div>
)}


    </ConsultantLayout>
  );
};

export default DiceSearch;
